import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { API_BASE } from '@/utils/api';

export const defaultPrintWidth = (paper) => (Number(paper) === 58 ? 48 : 72);

// Ancho imprimible editable de una impresora ya cargada
export const PrintWidthEditor = ({ printer, onSaved }) => {
  const [value, setValue] = useState(String(printer.printable_mm || defaultPrintWidth(printer.paper_width)));
  const [saving, setSaving] = useState(false);
  const dirty = Number(value) !== (printer.printable_mm || defaultPrintWidth(printer.paper_width));
  const save = async () => {
    const w = Number(value);
    if (!w || w < 30 || w > printer.paper_width) {
      toast.error(`El ancho imprimible tiene que estar entre 30 y ${printer.paper_width} mm`);
      return;
    }
    setSaving(true);
    try {
      const { printer_id, business_id, is_active, created_at, printable_mm, ...rest } = printer;
      await axios.put(`${API_BASE}/printers/${printer_id}`, { ...rest, print_width_mm: w });
      toast.success('Ancho imprimible guardado');
      onSaved?.();
    } catch (e) {
      toast.error(e.response?.data?.detail?.[0]?.msg || 'No se pudo guardar');
    } finally {
      setSaving(false);
    }
  };
  return (
    <div className="flex items-center gap-1.5">
      <span className="text-xs text-muted-foreground">Imprimible</span>
      <Input type="number" min={30} max={printer.paper_width} value={value} onChange={(e) => setValue(e.target.value)}
        className="h-8 w-16 text-xs" data-testid={`printer-width-input-${printer.printer_id}`} />
      <span className="text-xs text-muted-foreground">mm</span>
      {dirty && (
        <Button size="sm" variant="outline" className="h-8" onClick={save} disabled={saving} data-testid={`printer-width-save-${printer.printer_id}`}>
          Guardar
        </Button>
      )}
    </div>
  );
};
